<div class="ms-header-thumbnail d-flex align-items-center"
    [style.backgroundImage]="'url('+ src + ')'">
    <img src="{{src}}" alt="">
</div>
